import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { RequestMapper } from '../../request-mapper';
import { CommonUtilService } from '../../services/common-util/common-util.service';
@Component({
  selector: 'app-dp-success-message',
  standalone: true,
  imports: [MatDialogModule, MatIconModule, CommonModule, RouterModule],
  templateUrl: './dp-success-message.component.html',
  styleUrl: './dp-success-message.component.scss',
})
export class DpSuccessMessageComponent implements OnInit {
  router = '/home';
  public isMobileDevice: boolean = false;

  public reloadComponent: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<DpSuccessMessageComponent>,
    private isMobile: CommonUtilService
  ) {}
  ngOnInit() {
    this.isMobileDevice = this.isMobile.isMobileDevice();

    console.log('full data', this.data);

    this.reloadComponent = this.data.reload;
  }

  onCloseDialog() {
    this.dialogRef.close(true);
  }

  // oncloseAll() {
  //   this.dialog.closeAll();

  //   if (this.reloadComponent) {
  //     window.location.reload();
  //   }
  // }
}
